import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    canActivate: [authGuard]
  },
  {
    path: 'wareneingaenge',
    loadComponent: () =>
      import('./features/wareneingaenge/wareneingaenge.component').then(m => m.WareneingaengeComponent),
    canActivate: [authGuard]
  },
  {
    path: 'feedback',
    loadComponent: () => import('./features/feedback/feedback.component').then(m => m.FeedbackComponent),
    canActivate: [authGuard]
  },
  {
    path: 'datenschutz',
    loadComponent: () => import('./features/datenschutz/datenschutz.component').then(m => m.DatenschutzComponent),
    canActivate: [authGuard]
  },
  {
    path: 'zugang-gesperrt',
    loadComponent: () =>
      import('./features/zugang-gesperrt/zugang-gesperrt.component').then(m => m.ZugangGesperrtComponent)
  },
  { path: '**', redirectTo: '' }
];
